import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { matchNotations } from "@/components/expression/utils/switch-notations/cursorMatch";
import { ActionsDisclosure } from "@/components/sidebar/ActionsDisclosure";

import { SwitchNotationsList } from "./SwitchNotationsList";

import type { DocumentModel } from "@/models/DocumentModel";

export const SwitchNotations = observer(function SwitchNotations({ doc }: { doc: DocumentModel }) {
  const t = useTranslations("sidebar.switchNotations");
  const { cursor, selection } = doc.cursorContext();
  const { notations = [], nodes = [] } = matchNotations(cursor, selection);

  if (notations.length === 0 || nodes.length === 0) {
    return null;
  }

  return (
    <ActionsDisclosure
      title={t("title")}
      disclosureProps={{ defaultOpen: true }}
      className="w-full"
    >
      <SwitchNotationsList doc={doc} nodes={nodes} notations={notations} />
    </ActionsDisclosure>
  );
});
